import styled from 'styled-components';

import { BLACK, SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Wrapper = styled.div`
  padding-top: 85px;
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  flex-direction: column;
  margin: 0 auto 10px auto;
  margin-bottom: 0;
  ${media.tabletP`
    padding-top: 150px;
  `};
`;
export const ContentContainer = styled.div`
  flex: 1;
  flex-wrap: wrap;
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 2px 9.4px 0.6px rgba(0, 0, 0, 0.15);
  overflow-y: scroll;
  margin: 0 20px 20px 20px;
`;

export const ContentInner = styled.div`
  padding: 60px 0 5px 0;
  ${media.tabletP`
    padding: 60px 0 30px 0;
  `};
`;

export const ContentTitle = styled.div`
  text-align: center;
  font-size: 16px;
  color: ${BLACK};
  padding: 0 20px;
  ${media.tabletP`
    font-size: 22px;
    padding: 0;
  `};
`;

export const TitleText = styled.div`
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  color: ${BLACK};
  padding: 15px 0 25px 0;
  ${media.tabletP`
    font-size: 30px;
    padding: 15px 0 40px 0;
  `};
`;
export const ItemCareContainer = styled.div`
  width: 100%;
  flex-wrap: wrap;
  display: flex;
  flex-direction: column;
`;
export const ContentMainImage = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 150px;
  ${media.tabletP`
    height: calc(240 / 768 * 100vw);
  `};
`;

export const ContentMainImageText = styled.div`
  width: 55%;
  z-index: 1;
  padding: 10px 10px 10px 30px;
  ${media.tabletP`
    width: calc(100% - 310px);
    padding: 0 50px;
  `};
`;

export const ContentMainImageTitle = styled.div`
  font-size: 13px;
  color: #666666;
  ${media.tabletP`
    font-size: 16px;
  `};
`;

export const ContentMainImageDescription = styled.div`
  p {
    margin-top: 5px;
    font-size: 17px;
    color: ${BLACK};
    margin-bottom: 0;
  }
  ${media.tabletP`
    p {
      font-size: 23px;
    }
  `};
`;
export const ContentMainImageImage = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  right: 0px;
  ${media.tabletP`
    height: calc(240 / 768 * 100vw);
    object-fit: none;
  `};
`;

export const VideoSection = styled.section`
  margin: 17px auto 30px auto;
  max-width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 2}px;
  padding: 0 20px;
  ${media.tabletP`
    padding: 0;
    margin: 35px auto 60px auto;
  `};
`;
export const ItemCareStepContainer = styled.div`
  padding: 20px 0;
  margin: 0 20px;
  display: flex;
  flex-wrap: unset;
  flex-direction: row;
  position: relative;
  border-top: 1px solid #d7d7d7;
  ${media.tabletP`
    flex-wrap: wrap;
    margin: 0 55px;
    padding: 40px 0;
  `};
`;
// export const ItemCareStepContent = styled.div`
//   display: flex;
//   width: calc(100% - 144px);
//   padding-top: 30px;
//   padding-right: 15px;
// `
export const ItemCareStepImage = styled.div`
  flex: 2;
  min-height: 100px;
  ${media.tabletP`
    background: #eee;
    flex: 0 1 144px;
    height: 108px;
    min-height: unset;
    width: unset;
  `};
`;
export const ItemCareStepTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 3;
  ${media.tabletP`
    flex-direction: row;
  `};
`;
export const ItemCareStepTitle = styled.div`
  flex: calc(80% - 144px);
  font-size: 15px;
  font-weight: 500;
  padding-right: 20px;
  margin-bottom: 10px;
  color: ${BLACK};
  ${media.tabletP`
    font-size: 20px;
    flex: 0 0 16.1vw;
    margin-bottom: 0;
    width: 100px;
  `};
`;
export const ItemCareStepDescription = styled.div`
  flex: 2 1 calc(80% - 144px);
  padding-right: 20px;
  p {
    font-size: 14px;
    font-weight: 500;
    color: ${BLACK};
    margin-bottom: 0;
  }
  ol,
  ul {
    padding-top: 1em;
    padding-left: 1em;
  }
  li {
    font-size: 14px;
    margin-bottom: 6px;
  }
  ${media.tabletP`
    flex: 1 1 45vw;
    p {
      font-size: 18px;
    }
    li {
      font-size: 16px;
    }
  `};
`;
// export const ItemCareMemoContainer = styled.div`
//   margin-bottom: 30px;
// `
// export const ItemCareMemoContent = styled.ul`
//   font-size: 16px;
//   font-weight: 500;
//   color: ${BLACK};
//   list-style: none;
//   display: flex;
//   padding: 40px 0 40px 0;
//   margin: 0 55px;
//   border-top: 1px solid #d7d7d7;
//   &:last-child {
//   margin-bottom: 0;
//   padding-bottom: 0;
//   }
// `

// export const ItemCareMemoTitle = styled.li`
//   font-size: 20px;
//   padding-right: 40px;
//   color: ${BLACK};
// `

// export const ItemCareMemoDescription = styled.li`
//   font-size: 12px;
// `

// export const ItemCareMemo = styled.div`
//   font-size: 12px;
//   font-weight: 500;
//   color: ${BLACK};
//   padding-left: 0px;
// `



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicHomeCareStepPage/SublimicHomeCareStep.style.js